import React from 'react';
import styles from './TagsList.module.css';
import {Tag} from "../../types/api";
interface TagsListProps {
    tags: Tag[];
}
const TagsList: React.FC<TagsListProps> = ({ tags }) => {
    if (!tags || tags.length === 0) return null;
    return (
        <div className={styles.tags}>
            {tags.map((tag) => (
                <span key={tag.id} className={styles.tag}>#{tag.name}</span>
            ))}
        </div>
    );
};
export default TagsList;